import { useCallback } from 'react';
import { ChevronDown, ChevronRight } from 'react-feather';
import useGooglePlacesAutocomplete from '../../hooks/useGooglePlacesAutocomplete';
import { parseGooglePlaceAddress } from '../../utils/addressUtils';

export default function OrderAddressSection({
    register,
    setValue,
    errors,
    sections,
    toggleSection,
    reset
}) {
    const addressField = register('address', {
        required: 'Address is required',
    });

    const handlePlaceSelected = useCallback(
        (place) => {
            const parsedAddress = parseGooglePlaceAddress(place);

            setValue('address', parsedAddress.address, {
                shouldDirty: true,
                shouldValidate: true,
            });
            setValue('city', parsedAddress.city, {
                shouldDirty: true,
                shouldValidate: true,
            });
            setValue('state', parsedAddress.state, {
                shouldDirty: true,
                shouldValidate: true,
            });
            setValue('postalCode', parsedAddress.postalCode, {
                shouldDirty: true,
                shouldValidate: true,
            });
        },
        [setValue]
    );

    const { attachInputRef, autocompleteError } = useGooglePlacesAutocomplete({
        onPlaceSelected: handlePlaceSelected,
        enabled: sections.address,
    });

    return (
        <div className="tab-information">
            <div className="tab-information-block">
                <div
                    className="title-block"
                    onClick={(e) => toggleSection('address', e)}
                >
                    <h2 className="title-h2">Installation Address</h2>
                    <button type="button">
                        {sections.address ? (
                            <ChevronDown size={24} />
                        ) : (
                            <ChevronRight size={24} />
                        )}
                    </button>
                </div>
                {sections.address && (
                    <>
                        <div className="new-order-form">
                            <p className="instructions-p">
                                Please enter the address where the building will be installed.
                            </p>

                            <div className="field-section-half">
                                <div className="inp-col">
                                    <label htmlFor="address">
                                        <strong>Address</strong>
                                    </label>
                                    <input
                                        {...addressField}
                                        id="address"
                                        ref={(node) => {
                                            addressField.ref(node);
                                            attachInputRef(node);
                                        }}
                                    />
                                    {errors.address && (
                                        <p className="text-redColor-500 text-s italic p-2">
                                            {errors.address.message}
                                        </p>
                                    )}
                                    {autocompleteError && (
                                        <p className="text-s italic p-2">
                                            {autocompleteError} You can still type it manually.
                                        </p>
                                    )}
                                </div>

                                <div className="inp-col">
                                    <label htmlFor="city">
                                        <strong>City</strong>
                                    </label>
                                    <input
                                        {...register('city', {
                                            required: 'City is required',
                                        })}
                                    />
                                    {errors.city && (
                                        <p className="text-redColor-500 text-s italic p-2">
                                            {errors.city.message}
                                        </p>
                                    )}
                                </div>

                                <div className="inp-col">
                                    <label htmlFor="state">
                                        <strong>State</strong>
                                    </label>
                                    <input
                                        {...register('state', {
                                            required: 'State is required',
                                        })}
                                    />
                                    {errors.state && (
                                        <p className="text-redColor-500 text-s italic p-2">
                                            {errors.state.message}
                                        </p>
                                    )}
                                </div>

                                <div className="inp-col">
                                    <label htmlFor="postalCode">
                                        <strong>Postal Code</strong>
                                    </label>
                                    <input
                                        {...register('postalCode', {
                                            required: 'Postal Code is required',
                                        })}
                                    />
                                    {errors.postalCode && (
                                        <p className="text-redColor-500 text-s italic p-2">
                                            {errors.postalCode.message}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                // Clear only the address fields; keep the rest of the form intact
                                reset((prev) => ({
                                    ...prev,
                                    address: '',
                                    city: '',
                                    state: '',
                                    postalCode: '',
                                }));
                            }}
                            className="btn-tab-selection"
                        >
                            Different Address
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
